var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"RkmModal",attrs:{"buttons":['cancel', 'save'],"extraLarge":"","title":"Cadastrar Medicamento"},on:{"save":function($event){return _vm.$refs.Form.save()}}},[_c('Form',{ref:"Form",attrs:{"modelReceitaMedica":true},on:{"save":_vm.save}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }